module.exports = window.Vuex;